// extracted by mini-css-extract-plugin
export var root = "D_vr";
export var wrapper = "D_vs";
export var image = "D_vt d_w d_y d_W";
export var imageWithHeight = "D_vv";
export var crop = "D_vw";
export var round = "D_vx";
export var fixedHeight = "D_vy";